var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewTestBtnBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1857"
  }, /*#__PURE__*/React.createElement("g", {
    id: "review_test_btn-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-12",
    d: "M11.8828 3.88281H19.2708V5.10681H11.8828V3.88281Z",
    fill: "#323233"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-13",
    d: "M11.8828 6.33203H16.8218V7.55603H11.8828V6.33203Z",
    fill: "#323233"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1854"
  }, /*#__PURE__*/React.createElement("g", {
    id: "review_test_btn-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.18359 12.5551V3.49609H9.69059V12.5551H3.18359ZM4.26159 11.4771H8.61159V4.57709H4.26159V11.4771Z",
    fill: "#323233"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-24",
    d: "M11.8828 8.59668H19.2708V9.82068H11.8828V8.59668Z",
    fill: "#323233"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-25",
    d: "M11.8828 11.0459H16.8218V12.2699H11.8828V11.0459Z",
    fill: "#323233"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_73-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.699219,
    y: 0.700195,
    width: 20.6,
    height: 14.6,
    rx: 3.3,
    stroke: "#323233",
    strokeWidth: 1.4
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewTestBtnBlack);
export default __webpack_public_path__ + "static/media/review-test-btn-black.4f265803c4df53393c9d46be6cdd103b.svg";
export { ForwardRef as ReactComponent };